import React, { useState } from "react";
import { Badge, IconBtn } from "../../../design-system";
import { STATUS_LABEL, STATUS_TONE, EXT_COLORS } from "../constants";
import { extOf, formatBytes, formatDate, levelLabel } from "../helpers";

export function DocumentsTable({ rows, isManager, onOpen, onDownload }) {
  const cols = isManager
    ? "0.7fr 2fr 1fr 1fr 1fr 1fr 100px"
    : "0.7fr 2fr 1fr 1fr 1fr 100px";
  const minWidth = isManager ? 920 : 820;
  return (
    <div style={{ overflowX: "auto" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: cols,
          gap: 12,
          padding: "10px 20px",
          background: "var(--kr-neutral-50)",
          borderBottom: "1px solid var(--kr-border)",
          fontSize: 11,
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 600,
          color: "var(--kr-fg-muted)",
          minWidth,
        }}
      >
        <span>Código</span>
        <span>Documento</span>
        <span>Nivel</span>
        <span>Tipo</span>
        <span>Vigor</span>
        {isManager && <span>Estado</span>}
        <span style={{ textAlign: "right" }}>Acciones</span>
      </div>
      {rows.map((d, i) => (
        <DocRow
          key={d.id}
          d={d}
          last={i === rows.length - 1}
          cols={cols}
          minWidth={minWidth}
          isManager={isManager}
          onOpen={() => onOpen(d)}
          onDownload={() => onDownload(d)}
        />
      ))}
    </div>
  );
}

function DocRow({ d, last, cols, minWidth, isManager, onOpen, onDownload }) {
  const [hover, setHover] = useState(false);
  const ext = extOf(d.original_filename);
  const extColor = EXT_COLORS[ext] || ["var(--kr-neutral-100)", "var(--kr-fg-muted)"];
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onOpen}
      style={{
        display: "grid",
        gridTemplateColumns: cols,
        gap: 12,
        alignItems: "center",
        padding: "10px 20px",
        borderBottom: last ? "none" : "1px solid var(--kr-border-subtle)",
        background: hover ? "var(--kr-bg-subtle)" : "#fff",
        cursor: "pointer",
        fontSize: 13,
        minWidth,
      }}
    >
      <div
        style={{
          fontFamily: "var(--kr-font-mono, ui-monospace, monospace)",
          fontSize: 12,
          color: "var(--kr-fg-strong)",
          fontWeight: 600,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {d.code}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 6,
            background: extColor[0],
            color: extColor[1],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 9,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {ext || "DOC"}
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              color: "var(--kr-fg-strong)",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
              {d.title}
            </span>
            {d.my_acknowledgement?.status === "pending" && (
              <Badge tone="warning">Lectura pendiente</Badge>
            )}
          </div>
          <div style={{ color: "var(--kr-fg-muted)", fontSize: 11 }}>
            {d.original_filename} · {formatBytes(d.size_bytes)}
          </div>
        </div>
      </div>
      <div style={{ color: "var(--kr-fg-muted)", fontSize: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {levelLabel(d.level)}
      </div>
      <div style={{ color: "var(--kr-fg-muted)", fontSize: 12 }}>
        {d.type?.name || "—"}
      </div>
      <div style={{ color: "var(--kr-fg-muted)", fontSize: 12 }}>
        {formatDate(d.effective_at)}
      </div>
      {isManager && (
        <div>
          <Badge tone={STATUS_TONE[d.status] || "neutral"}>
            {STATUS_LABEL[d.status] || d.status}
          </Badge>
        </div>
      )}
      <div
        style={{ display: "flex", justifyContent: "flex-end", gap: 4 }}
        onClick={(e) => e.stopPropagation()}
      >
        <IconBtn icon="Download" title="Descargar" onClick={onDownload} />
        <IconBtn icon="Eye" title="Abrir" onClick={onOpen} />
      </div>
    </div>
  );
}
